import { useEffect, useState } from "react";
import MobileSidebar from "@/components/MobileSidebar";

/**
 * Global mount for MobileSidebar — lives once in App.tsx and listens for
 * window `openMobileMenu` events so any page can open the mobile drawer.
 */
export default function GlobalMobileSidebar() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const open = () => setIsOpen(true);
    window.addEventListener("openMobileMenu", open);
    return () => window.removeEventListener("openMobileMenu", open);
  }, []);

  return <MobileSidebar isOpen={isOpen} onClose={() => setIsOpen(false)} />;
}
